var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgScala = function SvgScala(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.067665 0 0 .067665 17.968 -3.2402)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m110 1682v-229l175-7c182-7 317-22 515-56 225-39 447-109 470-149 6-10 10 67 10 216v232l-26 20c-28 22-136 59-259 90-192 48-661 111-821 111h-64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110 1102v-229l175-6c194-8 345-25 545-62 224-42 428-110 443-147 3-7 6 90 6 216 1 200-1 232-16 248-35 39-305 109-583 152-169 26-449 56-527 56h-43z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110 526v-224l31-6c17-3 59-6 93-6 168 0 567-55 763-105 137-36 232-72 265-102 17-15 18-6 18 214 0 215-1 231-19 247-27 25-212 82-356 111-233 46-620 95-752 95h-43z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgScala, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/scala.5648e821.svg";
export { ForwardRef as ReactComponent };